import React, { lazy, useEffect, useState, useRef } from 'react';
import { binarySearchLte } from '../../../functions/binarySearch';
import { accordianexpand } from '../../../paths/defaultImage';
import SuspenseWrapper from '../suspenseWrapper';
import LazyImage from '../lazyLoad';
const MenuPopUp = lazy(() => import(/* webpackChunkName:"MenuPopUp"*/ '../menuPopUp'));

const DropDownButton = ({ list, customClass, btnWidth, showPopupVal }) => {
  const [selected, setSelected] = useState();
  const [listScrollY, setListScrollY] = useState([]);
  const [globalScrollY, setGlobalScrollY] = useState(window.scrollY);
  const categoryRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const clickHandler = () => {
    setShowPopup(true);
    showPopupVal(true);
  };
  useEffect(() => {
    let listScrollTop = [];
    list?.map((element, index) => {
      const scrollYPosition =
        document.getElementById('uniquiMenuId' + String(index))?.getBoundingClientRect().y +
        window.scrollY -
        194;
      listScrollTop.push(scrollYPosition);
    });
    setListScrollY([...listScrollTop]);
  }, [list]);

  useEffect(() => {
    window.removeEventListener('scroll', () => {});

    window.addEventListener('scroll', () => {
      if (categoryRef?.current) return;
      setGlobalScrollY(window.scrollY);
      let index = binarySearchLte(listScrollY, window.scrollY || globalScrollY);
      if (index == -1) index = 0;
      if (selected != list[index]?.name) {
        index ? setSelected(list[index]?.name) : setSelected(list[0]?.name);
      }
    });
  }, [listScrollY, globalScrollY]);

  useEffect(() => {
    if (list) {
      setSelected(list[0]?.name);
    }
  }, [list]);

  return (
    <>
      <div
        className={`btn ${customClass || 'dropdownBtn  appHeader'} px-3 `}
        style={{ width: `${btnWidth}%`, height: '2.5rem' }}>
        <div
          className='fw-600 d-flex align-items-center w-100 justify-content-between'
          style={{ height: '100%' }}
          onClick={clickHandler}>
          <div className=' overflow-ellipsis'>{selected}</div>
          <LazyImage
            src={accordianexpand}
            alt='collapse-expand'
            className='rotate-collapse-icon udarrow'
          />
        </div>
      </div>
      {showPopup && (
        <SuspenseWrapper>
          <MenuPopUp
            menuItems={list}
            categoryRef={categoryRef}
            setdropdown={setSelected}
            close={() => {
              setShowPopup(false);
              showPopupVal(false);
            }}
          />
        </SuspenseWrapper>
      )}
    </>
  );
};

export default DropDownButton;
